// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + (chunkId === 620 ? "pdfjsWorker" : chunkId) + "." + {"620":"3ddc8260","851":"9e22410d"}[chunkId] + ".chunk.js";
};